var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { class: ["mobile-account", { active: _vm.active }] }, [
    _vm.LOGGED_IN
      ? _c(
          "a",
          { staticClass: "link", attrs: { href: "/account/promotions" } },
          [
            _c("f-sprite-icon", {
              attrs: { "icon-link": _vm.$options.icons.IconNotifications.id }
            }),
            _vm._v("\n    Уведомления\n    "),
            _c("ui-badge", {
              attrs: { text: _vm.PROMOS_COUNT, color: "#F34744" }
            })
          ],
          1
        )
      : _vm._e(),
    _c(
      "span",
      { staticClass: "link", on: { click: _vm.accountClick } },
      [
        _c("f-sprite-icon", {
          attrs: { "icon-link": _vm.$options.icons.IconUser.id }
        }),
        _vm._v("\n    " + _vm._s(_vm.title) + "\n    "),
        _vm.LOGGED_IN
          ? _c("ui-badge", { attrs: { text: _vm.bonuses, color: "#95D4E9" } })
          : _vm._e()
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "tree-menu depth2" },
      [
        _c(
          "vue-client-only",
          [
            _c("mobile-menu-header", {
              attrs: { title: _vm.title, "show-back": "" },
              on: {
                back: function($event) {
                  $event.stopPropagation()
                  return _vm.$f.showNav()
                }
              }
            })
          ],
          1
        ),
        _c("div", { staticClass: "mobile-account-container" }, [
          _c("a", { staticClass: "link", attrs: { href: "/account" } }, [
            _vm._v("Профиль "),
            _c("span", [_vm._v(_vm._s(_vm.ACCOUNT.firstName))])
          ]),
          _c("a", { staticClass: "link", attrs: { href: "/account/orders" } }, [
            _vm._v("Заказы")
          ]),
          _c(
            "a",
            { staticClass: "link", attrs: { href: "/account/addresses" } },
            [_vm._v("Адреса")]
          ),
          _c(
            "a",
            { staticClass: "link", attrs: { href: "/account/favorites" } },
            [
              _vm._v("Избранное"),
              _c("ui-badge", {
                attrs: {
                  text: _vm.favoritiesCount,
                  size: "large",
                  color: "#f34744"
                }
              })
            ],
            1
          ),
          _c(
            "a",
            { staticClass: "link", attrs: { href: "/account/subscribes" } },
            [_vm._v("Подписки")]
          ),
          _c(
            "a",
            { staticClass: "link", attrs: { href: "/account/club" } },
            [
              _vm._v("Клубная программа"),
              _c("ui-badge", {
                attrs: { text: _vm.bonuses, size: "large", color: "#95D4E9" }
              })
            ],
            1
          ),
          _c(
            "a",
            { staticClass: "link", attrs: { href: "/account/logout" } },
            [
              _vm._v("Выход"),
              _c("f-sprite-icon", {
                attrs: { "icon-link": _vm.$options.icons.IconExit.id }
              })
            ],
            1
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }